import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { FaInstagram, FaLinkedin, FaYoutube } from "react-icons/fa";
import JeevanLogo from "./images/JeevanLogo.webp";


const Footer = () => {
  return (
    <footer className="bg-black text-white py-4 footerhgt">
      <Container>
        <Row className="align-items-center">
          {/* Left Section */}
          <Col md={4} className="mb-3 mb-md-0 footer-column">
            <img src={JeevanLogo} alt="Jeevan Infotech" height="40" className="mb-2" />
            <div className="">Jeevan Infotech</div>
            <p className="mb-2">Pioneer in Apparel & Textile Automation</p>
            <div className="d-flex gap-3 footer-icons">
              <FaInstagram size={20} />
              <FaLinkedin size={20} />
              <FaYoutube size={20} />
            </div>
          </Col>

          {/* Center Section */}
          <Col md={5} className="d-flex justify-content-md-center footer-column">
<ul className="list-unstyled d-flex gap-4 mb-0">
  <li>
    <strong>Products</strong>
    <ul className="list-unstyled small mt-1">
      <Link to="/operation360" className="footerlist"><li>Operation 360</li></Link>
      <Link to="/synergy360" className="footerlist"><li>Synergy 360</li></Link>
    </ul>
  </li>

  <Link to="/pricing" className="footerlist"><li>Pricing</li></Link>
  {/* <Link to="/blogpage" className="footerlist"><li>Blog</li></Link> */}
  <ul  className="list-unstyled small mt-1">
  {/* Contact Us */}
  <Link to="/contactform" className="footerlist"><li>Contact Us</li></Link>
  {/* ✅ Support (mailto) just below Contact Us */}
  <li>
    {/* <a 
      href="mailto:info@toodhu.com?subject=Support%20Request%20-%20Toodhu&body=Dear%20Toodhu%20Support%20Team,%0D%0A%0D%0AI%20would%20like%20to%20get%20in%20touch%20regarding%20your%20services.%0D%0A%0D%0AMessage:%20%0D%0A%0D%0AI%20look%20forward%20to%20your%20response.%0D%0A%0D%0ABest%20regards,%0D%0A[Your%20Name]"
      className="footerlist"
    >
      Support
    </a> */}
    <a
  href="https://mail.google.com/mail/?view=cm&fs=1&to=info@toodhu.com&su=Support%20Request%20-%20Toodhu&body=Dear%20Toodhu%20Support%20Team,%0D%0A%0D%0AI%20would%20like%20to%20get%20in%20touch%20regarding%20your%20services.%0D%0A%0D%0AMessage:%20%0D%0A%0D%0AI%20look%20forward%20to%20your%20response.%0D%0A%0D%0ABest%20regards,%0D%0A[Your%20Name]"
  target="_blank"
  rel="noopener noreferrer"
  className="footerlist"
>
  Support
</a>
  </li>
  </ul>

</ul>
          </Col>

          {/* Right Section */}
          <Col md={3} className="footer-column">
            <Link to="/privacy" style={{ textDecoration: 'none' }}><p className="small mb-1 footerprivacy">Privacy Policy</p></Link>
            <Link to="/terms" style={{ textDecoration: 'none' }}><p className="small mb-1 footerprivacy">Terms & Conditions</p></Link>
            <p className="small mb-0 allrights">All Rights Reserved.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;